import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSnowNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4.176 15.8l-2.952 1.7.676 1.169 2.952-1.7.13 3.763L6.3 19.97l.012.019-.137-3.789 3.19-1.842 1.95 1.03v3.657l-3.341 1.782H8v1.517l3.325-1.767V24h1.35v-3.423L16 22.346v-1.519h.019l-3.348-1.779V15.39l1.939-1.03h.006l3.194 1.84-.132 3.788.01-.019 1.312.76.13-3.763 2.953 1.7.676-1.169-2.953-1.7L23 13.8l-1.313-.758.01-.019-3.214 2.008-3.183-1.838.01-2.416 3.177-1.837 3.213 2.009-.011-.02 1.31-.758-3.191-2 2.952-1.7-.672-1.171L19.136 7l-.131-3.764L17.69 4l-.011-.019.132 3.789-3.19 1.842-1.951-1.031V4.923l3.347-1.78H16V1.624l-3.33 1.77V0h-1.35v3.394L8 1.625v1.518h-.026l3.347 1.78v3.656L9.37 9.62 6.175 7.776l.133-3.789-.012.02-1.314-.759-.131 3.764L1.9 5.306l-.68 1.169 2.956 1.706-3.193 2 1.313.758-.011.019L5.5 8.946l3.18 1.836V13.2L5.5 15.031l-3.214-2.009.01.02-1.313.758 3.193 2zm5.854-5L12 9.75l1.96 1.04-.01 2.39L12 14.22l-1.97-1.04V10.8z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsSnowNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSnowNormalSmall;
